import SignalTable from 'components/global/SignalTable/SignalTable';
import SimpleCard from 'components/global/SimpleCard';
import InvestorInviteRows from 'components/views/InvestorTeam/_components/InvestorInviteRow';
import { fetchAndSetInvestorInvites } from 'components/views/InvestorTeam/_helpers/investorTeam.resolvers';
import { $list, $view } from 'signals/global.signals';
import useEffectAsync from 'utils/useEffectAsync';

const InvestorInvites = () => {
  useEffectAsync(fetchAndSetInvestorInvites);
  return (
    <SimpleCard>
      <SignalTable
        headers={[{
          value: 'Email',
          key: 'email',
        },
        {
          value: 'Team',
          key: 'team',
        },
        {
          value: 'Type',
          key: 'type',
        },
        {
          value: 'Actions',
          key: 'Actions',
        }]}
        rows={InvestorInviteRows({ data: $list.value.data || [] })}
        isLoading={$view.value.isTableLoading}
      />
    </SimpleCard>
  );
};

export default InvestorInvites;
